import { differenceInSeconds, format, parse, parseISO } from 'date-fns'

export const _calculateAge = (birthDateNumber) => {
  if (birthDateNumber) {
    var today = new Date()
    var birthDate = new Date(birthDateNumber)
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      // age--;
      age = age - 1
    }
    return `(${age} years old)`
  }
  return '(No age)'
}

export const monthCheckerForNumberOfDays = (month, year) => {
  if (!month || !year) {
    return
  }
  let leapYear = year % 4 === 0
  switch (month) {
    case 0: // January
      return 31
    case 1: // February
      if (leapYear) {
        return 29
      } else {
        return 28
      }
    case 2: // March
      return 31
    case 3: // April
      return 30
    case 4: // May
      return 31
    case 5: // June
      return 30
    case 6: // July
      return 31
    case 7: // August
      return 31
    case 8: // September
      return 30
    case 9: // October
      return 31
    case 10: // November
      return 30
    case 11: // December
      return 31
    default: // Default Day
      return 31
  }
}

export const _convertAPIDate = (dateOld) => {
  if (!dateOld) {
    return null
  }
  let date = new Date(dateOld)
  let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  let newDOB = `${date.getFullYear()}-${month}-${day}`
  return newDOB
}

export const _calculateWorkExperienceYear = (workDateNumber) => {
  if (!workDateNumber || workDateNumber === '') {
    return
  }
  var today = new Date()
  var commenceDate = new Date(workDateNumber)
  var age = today.getFullYear() - commenceDate.getFullYear()
  var diffMonth = today.getMonth() - commenceDate.getMonth()
  var diffDay = today.getDate() - commenceDate.getDate()
  var diffMonth2
  var removeNegativeMonth

  if (diffDay < 0) {
    diffMonth2 = diffMonth - 1
  } else {
    diffMonth2 = diffMonth
  }

  if (diffMonth2 < 0) {
    removeNegativeMonth = 12 + diffMonth2
  } else {
    removeNegativeMonth = diffMonth2
  }

  if (diffMonth < 0 || (diffMonth === 0 && today.getDate() < commenceDate.getDate())) {
    // age--;
    age = age - 1
  }
  if (age > 0) {
    return `(${age + ` ${age === 1 ? 'year' : 'years'}`}${
      removeNegativeMonth > 0
        ? `, ${removeNegativeMonth} ` + (removeNegativeMonth === 1 ? 'month' : 'months')
        : ''
    })`
  } else if (removeNegativeMonth > 0) {
    return `(${removeNegativeMonth} ${removeNegativeMonth === 1 ? 'month' : 'months'})`
  } else {
    if (diffDay < 0 && diffMonth === 1) {
      return `(${
        monthCheckerForNumberOfDays(commenceDate.getMonth(), commenceDate.getFullYear()) + diffDay
      } ${diffDay === 1 ? 'day' : 'days'})`
    } else if (diffDay > 0 && diffMonth === 0) {
      return `(${diffDay} ${diffDay === 1 ? 'day' : 'days'})`
    } else if (diffDay === 0) {
      return 'Started today'
    }
  }
}

export const _ICBirthdateValidation = (newValues) => {
  let currentDate = new Date(newValues.dob)
  // Year
  let currentYear = currentDate.getFullYear()
  let filterYear = currentYear.toString().substring(2, 4)
  // Month
  let currentMonth = currentDate.getMonth() + 1
  let filterMonth = currentMonth < 10 ? `0${currentMonth}` : currentMonth
  // Day
  let currentDay = currentDate.getDate()
  let filterDay = currentDay < 10 ? `0${currentDay}` : currentDay
  // DOB into IC
  let stringDate = `${filterYear}${filterMonth}${filterDay}`
  let filterIC = newValues.id_number.substring(0, 6)

  let isMatched = stringDate === filterIC

  return isMatched
}

export const formatTimeAmPm = (dateString) => {
  const date = new Date(dateString)
  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'

  hours = hours % 12 || 12 // Convert to 12-hour format, replacing '0' with '12'

  return `${hours}:${minutes} ${ampm}`
}

export const timeDifference = (startDate, endDate) => {
  const diffInMs = endDate - startDate // Difference in milliseconds

  // Convert milliseconds to seconds, minutes, and hours
  const hours = Math.floor(diffInMs / (1000 * 60 * 60))
  const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000)

  // Ensure two digits format for minutes and seconds
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const formattedSeconds = seconds.toString().padStart(2, '0')

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
}

export const formatToDDMMYYYY = (isoDate) => {
  const date = new Date(isoDate)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

export const timeObjectToDateConverter = (time) => format(time, 'dd/MM/yyyy')

export const getDayOfDate = (dateString) => {
  const date = parseISO(dateString)
  // Format the date to return the day of the week (e.g., "Mon") 3 letters, use EEEE for full day name
  return format(date, 'EEE')
}

export const calculateTimeDifferenceFormatted = (time1, time2) => {
  const formatWithSeconds = 'HH:mm:ss'
  const formatWithoutSeconds = 'HH:mm'

  // Determine if input includes seconds
  const isWithSeconds = (time) => time?.length === 8

  // Parse the time strings based on their format
  const date1 = isWithSeconds(time1)
    ? parse(time1, formatWithSeconds, new Date(0, 0, 0))
    : parse(time1, formatWithoutSeconds, new Date(0, 0, 0))

  const date2 = isWithSeconds(time2)
    ? parse(time2, formatWithSeconds, new Date(0, 0, 0))
    : parse(time2, formatWithoutSeconds, new Date(0, 0, 0))

  // Find the absolute difference in seconds
  const diffInSeconds = Math.abs(differenceInSeconds(date1, date2))

  // Convert seconds into hours, minutes, and optionally seconds
  const hours = Math.floor(diffInSeconds / 3600)
    .toString()
    .padStart(2, '0')
  const minutes = Math.floor((diffInSeconds % 3600) / 60)
    .toString()
    .padStart(2, '0')

  if (isWithSeconds(time1) && isWithSeconds(time2)) {
    const seconds = (diffInSeconds % 60).toString().padStart(2, '0')
    return `${hours}:${minutes}:${seconds}`
  } else {
    return `${hours}:${minutes}`
  }
}

export const formatTimer = (seconds) => {
  const hours = String(Math.floor(seconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0')
  const sec = String(seconds % 60).padStart(2, '0')
  return `${hours}:${minutes}:${sec}`
}

export const formatToYYYYMMDD = (dateObject) => {
  const formattedDate = format(new Date(dateObject), 'yyyy-MM-dd')
  return formattedDate
}

export const formatTimeToAmPm = (dateString, noSeconds = false) => {
  if (noSeconds) {
    const time = parse(dateString, 'HH:mm', new Date(0))
    const formattedTime = format(time, 'hh:mm aaa')
    return formattedTime
  } else {
    const time = parse(dateString, 'HH:mm:ss', new Date(0))
    const formattedTime = format(time, 'hh:mm aaa')
    return formattedTime
  }
}

export const formatTimeToAmPmWithSeconds = (timestamp) => {
  if (!timestamp) return '--:--:--'

  const date = new Date(timestamp)
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12 // Convert 0 to 12 for 12-hour format
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const formattedSeconds = seconds.toString().padStart(2, '0')

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`
}

export const extractFormattedDateInfo = (data) => {
  let result = {}

  Object.keys(data).forEach((dateStr) => {
    const date = new Date(dateStr)
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' })
    const dayOfMonth = String(date.getDate()).padStart(2, '0')

    result = {
      day_of_week: dayOfWeek,
      day_of_month: dayOfMonth,
    }
  })

  return result
}
